// carrier-entry.ts — resolve ONE carrier / status entry of a compiled row to its definition, for the movement lanes' trigger scans
// (plain-walk-scope, force-move, fall-check). A compiled bucket holds four shapes:
//   - a bare UUID string;
//   - a reference `{ item_id, source, … }` / a status `{ status_item_id, … }` — the definition lives in the encounter catalog;
//   - a wrapper `{ item_arr | status_arr: <definition> }`;
//   - a BARE inline definition `{ items: { item_id, … }, item_layer_types?, … }` — the entry IS the item.
// The bare definition names itself under `items.item_id`, not at the top: reading only `item_id` resolved it to '' and every
// scan reported it "not loaded" (owner report 2026-09-30: a party member's layerless "Thirst of Isha" refused every Force Move of
// a creature beside it as "leaving a watcher's reach fires an authored reaction").
type Row = Record<string, unknown>;
const record = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;

export function carrierEntryDefinition(entry: unknown, definition: (id: string) => Row | null): { id: string; definition: Row | null } {
  const wrapper = record(entry);
  const embedded = wrapper && (record(wrapper.status_arr) ?? record(wrapper.item_arr));
  const bare = wrapper && !embedded && wrapper.status_item_id === undefined && wrapper.item_id === undefined ? record(wrapper.items) : null;
  const id = String(wrapper?.status_item_id ?? wrapper?.item_id ?? record(embedded?.items)?.item_id ?? bare?.item_id
    ?? (typeof entry === 'string' ? entry : ''));
  if (embedded && record(embedded.item_layer_types)) return { id, definition: embedded };
  if (bare && record(wrapper!.item_layer_types)) return { id, definition: wrapper };
  return { id, definition: id ? definition(id) : null };
}
